import { Text } from '@chakra-ui/layout'
import React, { forwardRef } from 'react'

const Helper = forwardRef((props, ref) => {
  return (
    <Text lineHeight="normal" fontSize="0.875em" color="gray.500" ref={ref} {...props} />
  )
})

Helper.displayName = 'HelperText'

export default Helper
